import { FC } from 'react'
import { withHeaderHOC } from 'shared/HOCs/withHeaderHOC'
import { withSideBarHOC } from 'shared/HOCs/withSidebarHOCs'

import { LeadTime } from 'widgets/_Accordions/LeadTime'
import { AddressAccordion } from 'widgets/_Accordions/Address'
import { ExtraOptionsAccordion } from 'widgets/_Accordions/ExtraOptions'
import { PaymentOptionsAccordion } from 'widgets/_Accordions/PaymentOptions'
import { InterfaceDesignAccordion } from 'widgets/_Accordions/InterfaceDesign'
import { TermsConditionsAccordion } from 'widgets/_Accordions/TermsConditions'
import { LanguagesAccordion } from 'widgets/_Accordions/Languages'
import { withIFrameHOC } from 'shared/HOCs/withIFrameHOC'

export const CompanyPage: FC = () => {
  return (
    <>
      <AddressAccordion />
      <InterfaceDesignAccordion />
      <PaymentOptionsAccordion />
      <LanguagesAccordion />
      <ExtraOptionsAccordion />
      <LeadTime />
      <TermsConditionsAccordion />
    </>
  )
}

// TODO: translations
export const Company = withSideBarHOC(withIFrameHOC(withHeaderHOC(CompanyPage, 'Company')))
